.root {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--paletteNeutral1);
  padding: var(--spacingMd);
}

.historyContainer {
  display: flex;
  flex-direction: column;
  gap: var(--spacingLg);
}

.attributesContainer {
  padding-left: var(--spacingLg);
}

.attributes {
  display: flex;
  flex-direction: column;
  gap: var(--spacingMd);
}
